import { Button, Icon, Image, Typography, VerticalDivider } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { EmptyTableContent } from '@hero/components/molecules/EmptyTableContent';
import { BADGES } from '@hero/constants';
import { useCreateAutomationModal } from '@hero/hooks';
import { ROUTE_PATHS } from '@hero/routes';
import { useGetAutomations } from '@hero/services/order-service';

import * as S from './style';

const TABLE_LIMIT = 4;

export function RecentAutomationCards() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { showCreateAutomationModal } = useCreateAutomationModal();

  const { data: myAutomations } = useGetAutomations({
    pagination: {
      page: 1,
      limit: TABLE_LIMIT
    }
  });

  return (
    <S.AutomationWrapper>
      <S.Header>
        <Icon name="automation" />
        <Typography variant="body1Bold">{t('recentAutomations')}</Typography>
        <VerticalDivider $height="16px" />
        <Button variant="link" onClick={() => navigate(ROUTE_PATHS.MY_AUTOMATION_LIST)}>
          {t('seeAll')}
        </Button>
      </S.Header>

      {myAutomations?.docs?.length > 0 ? (
        <S.ListContainer>
          {myAutomations?.docs.map((doc, index) => (
            <S.AutomationCard
              key={`${doc}-${index}`}
              color={BADGES[doc.status].color}
              background={BADGES[doc.status].background}
            >
              <S.CardContent>
                <Typography variant="body2Bold">{doc.name}</Typography>
                <S.EmptyLine />
                <Typography variant="caption1Bold">{`# ${t('recipients')}`}</Typography>
                <Typography variant="caption1">
                  {doc.contacts?.ids?.length || doc.contacts?.maxCount || 0}
                </Typography>
                <S.EmptyLine />
                <Typography variant="caption1Bold">{t('gifts')}</Typography>
                <S.ProductArea>
                  {doc?.products.splice(0, 3).map(product => {
                    return (
                      <S.ProductAvatar key={product.merchantProductId}>
                        <Image src={product?.images?.[0]?.url} width="100%" />
                      </S.ProductAvatar>
                    );
                  })}
                </S.ProductArea>
              </S.CardContent>
              <S.CardFooter>
                <S.CardFooterDot />
                {BADGES[doc.status].title}
              </S.CardFooter>
            </S.AutomationCard>
          ))}
        </S.ListContainer>
      ) : (
        <EmptyTableContent
          createNew={showCreateAutomationModal}
          feature="automation"
          icon="calendarIconPlaceholder"
        />
      )}
    </S.AutomationWrapper>
  );
}
